import * as React from "react";
import { LiveAdTile } from "../../components";
import { AddIcon } from "../../components/icons";
import "./index.css";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import {
  useDeleteClassifiedByUserMutation,
  useGetClassifiedByUserQuery,
} from "../../features/supabase/usecase/classifieds";
import { toast } from "react-toastify";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import { useSelector } from "react-redux";
import { selectAuth } from "../../features/auth/authSlice";

const DashboardPage = () => {
  const [tab, setTab] = React.useState("approved");
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [selectedClassifiedId, setSelectedClassifiedId] = React.useState(null);
  const [params, setParams] = useSearchParams();

  const {
    data: result,
    error,
    isLoading,
    refetch,
  } = useGetClassifiedByUserQuery();

  const [deleteClassified] = useDeleteClassifiedByUserMutation();


  const user = useSelector(selectAuth);

  const navigate = useNavigate();

  React.useEffect(() => {
    if (!user) {
      navigate("/")
    }
  }, [user]);

  React.useEffect(() => {
    if (params.get("tab")) {
      setTab(params.get("tab"));
    }
  }, [params]);


  const handleTabChange = (tab) => {
    const newParams = new URLSearchParams();
    newParams.set("tab", tab);
    setParams(newParams);
  };

  const onConfirm = async () => {
    if (!selectedClassifiedId) return;

    const toastId = toast("Deleting...", {
      autoClose: false,
      isLoading: true,
      closeButton: false,
    });

    const result = await deleteClassified(parseInt(selectedClassifiedId));
    if (result.error) {
      toast.update(toastId, {
        render: result.error.message || "An error occurred",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } else {
      toast.update(toastId, {
        render: "Ad deleted",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      refetch();
    }


    setShowConfirm(false);
    setSelectedClassifiedId(null);
  };

  const onClose = () => {
    setShowConfirm(false);
    setSelectedClassifiedId(null);
  };

  const handleDeleteClick = (id) => {
    setSelectedClassifiedId(id);
    setShowConfirm(true);
  };

  if (isLoading) {
    return (
      <section className="loader-section">
        <span className="loader"> </span>
      </section>
    );
  }

  return (
    <div className="dashboard-base">
      <div className="dashboard-header">
        <div className="dashboard-title">
          <span className="text-sm"></span>
          <span></span>
        </div>
        <NavLink
          to="/submit"
          title={"New listing"}
          className={"new-listing-btn"}
        >
          <AddIcon stroke={"white"} size={25} fill={"white"} />
          <div>New Listing</div>
        </NavLink>
      </div>
      <div className="dashboard-body">
        <div className="tab-btn-group">
          <span
            className={`tab-btn ${tab === "approved" ? "active" : ""}`}
            onClick={() => handleTabChange("approved")}
          >
            Live ads
          </span>
          <span
            className={`tab-btn ${tab === "draft" ? "active" : ""}`}
            onClick={() => handleTabChange("draft")}
          >
            Drafts
          </span>
          <span
            className={`tab-btn ${tab === "pending" ? "active" : ""}`}
            onClick={() => handleTabChange("pending")}
          >
            Pending
          </span>
          <span
            className={`tab-btn ${tab === "expired" ? "active" : ""}`}
            onClick={() => handleTabChange("expired")}
          >
            Expired
          </span>
        </div>
        <div className="tab-content">
          <div className="dashboard-tab-grid live-ad">
            {Array.from(result ?? [])
              .filter((classified) => classified.status === tab)
              .map((classified, index) => (
                <LiveAdTile
                  key={index}
                  redirectUrl={
                    tab === "draft" || tab === "expired"
                      ? `/submit?edit=${classified.id}`
                      : `/edit/${classified.id}`
                  }
                  classified={classified}
                  onDelete={() => handleDeleteClick(classified.id)}
                />
              ))}
          </div>
        </div>
      </div>

      {showConfirm && (
        <ConfirmDialog
          title={"Delete Classified"}
          subtitle={"Are you sure you want to delete this classified?"}
          onConfirm={onConfirm}
          onClose={onClose}
        />
      )}
    </div>
  );
};

export default DashboardPage;
